import axios from "axios";
import config from "../Config.json";

const VerifyOtp = async (data) => {
    try {       
        const response = await axios.post(`${config.API_URL}/app/verifyOTP`, data)
        return response
    } catch (error) {
        return error
    }
}

export default VerifyOtp;